import React from 'react';

import { Box } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';
import { useIntl } from 'react-intl';

import { A11yWrapper } from 'components/a11y-wrapper';
import PickupTimeSelector from 'components/pickup-time-selector';
import { TopServiceMode } from 'components/top-service-mode';
import { routes } from 'utils/routing';
import { isDelivery } from 'utils/service-mode';

import SectionHeading from '../section-heading';

import DeliveryDetails from './delivery-details';
import { PickupDetails } from './pickup-details';
import { ChangeLink, HeadingContainer, PickupTimeHeadingContainer } from './styled';
import { ICartDetailsProps } from './types';

export const DetailsV2: React.FC<React.PropsWithChildren<ICartDetailsProps>> = ({
  readOnly = false,
  onTimeSelectorChange,
  onDeliveryStatusChange,
  timeSelectorValue,
  serverOrder,
  serviceMode,
  setAreDeliveryDetailsValid,
  isOrderTimedFire,
  isPickupTimeAvailable,
  phoneNumberInputRef,
  deliveryDetailsErrors,
}) => {
  const router = useRouter();
  const { formatMessage } = useIntl();

  const isDeliveryOrder = isDelivery(serviceMode);

  const handleChangeStorePress = () => {
    router.navigate(isDeliveryOrder ? routes.deliveryAddress : routes.storeLocator);
  };

  const sectionHeading = isDeliveryOrder ? 'deliveryDetails' : 'restaurantDetails';

  return (
    <>
      <HeadingContainer
        alignItems={isDeliveryOrder ? 'center' : undefined}
        justifyContent={isDeliveryOrder ? 'center' : undefined}
        flexDirection={isDeliveryOrder ? undefined : 'column'}
      >
        <A11yWrapper>
          <SectionHeading focusable marginBottom="$0" marginTop="$0">
            {formatMessage({
              id: sectionHeading,
            })}
          </SectionHeading>
        </A11yWrapper>
        {isDeliveryOrder ? (
          <ChangeLink
            onPress={handleChangeStorePress}
            accessibilityLabel={formatMessage({
              id: 'changeAddressAriaLabel',
            })}
            isUnderlined
          >
            {formatMessage({ id: 'changeAddress' })}
          </ChangeLink>
        ) : (
          <TopServiceMode isInCart={true} />
        )}
      </HeadingContainer>
      {isDeliveryOrder ? (
        <DeliveryDetails
          serverOrder={serverOrder}
          setAreDeliveryDetailsValid={setAreDeliveryDetailsValid}
          sectionHeading={sectionHeading}
          phoneNumberInputRef={phoneNumberInputRef}
          deliveryDetailsErrors={deliveryDetailsErrors}
        />
      ) : (
        <PickupDetails serviceMode={serviceMode} readOnly={readOnly} />
      )}
      {isOrderTimedFire && (
        <Box>
          <PickupTimeHeadingContainer>
            <SectionHeading>
              {isDeliveryOrder
                ? formatMessage({ id: 'deliveryTime' })
                : formatMessage({ id: 'pickUpTime' })}
            </SectionHeading>
          </PickupTimeHeadingContainer>
          <PickupTimeSelector
            onChange={value => onTimeSelectorChange && onTimeSelectorChange(value)}
            onDeliveryStatusChange={onDeliveryStatusChange}
            isPickupTimeAvailable={isPickupTimeAvailable}
            showAsTime
            value={timeSelectorValue || 0}
          />
        </Box>
      )}
    </>
  );
};
